



import Check from "rutas/check";
import Casas from "views/casa";
import ReportesDiagnosticoMunicipal from "views/diagnostico/reportes/reportes_diagnostico_municipal";
import ReportesTratamientoMunicipal from "views/diagnostico/reportes/reportes_tratamiento_municipal";
import EstratificadoEe2 from "views/estadistica/estratificado/estratificado";
import Ee2Encargado from "views/evaluacion/encargado/ee2";
import RociadoRR2 from "views/evaluacion/encargado/Rociado";
import MSDK from "views/maps/m-sdk";


var routes = [

  {
    path: "/tratamientos",
    name: "TRATAMIENTOS",
    icon: " tim-icons  icon-book-bookmark",
    component: <ReportesTratamientoMunicipal />,
    layout: "/ee-2-jefe-municipal",
  },

  {
    path: "/diagnosticos",
    name: "DIAGNOSTICOS",
    icon: " tim-icons  icon-book-bookmark",
    component: <ReportesDiagnosticoMunicipal />,
    layout: "/ee-2-jefe-municipal",
  },



  {
    path: "/EE-2",
    name: "EE-2",
    icon: " tim-icons  icon-book-bookmark",
    component: <Ee2Encargado />,
    layout: "/ee-2-jefe-municipal",
  },

  {
    path: "/RR2-CH-MA",
    name: "RR2-CH-MA",
    icon: " tim-icons  icon-book-bookmark",
    component: <RociadoRR2 />,
    layout: "/ee-2-jefe-municipal",
  },
  {
    path: "/estratificado",
    name: "Estratificado",
    icon: "tim-icons  icon-book-bookmark",
    component: <EstratificadoEe2 />,
    layout: "/ee-2-jefe-municipal",
  },
  {
    path: "/viviendas",
    name: "Viviendas",
    icon: "tim-icons icon-bank",
    component: <Casas />,
    layout: "/ee-2-jefe-municipal",
  },
  {
    path: "/georef",
    name: "Georeferenciaciones",
    icon: "tim-icons icon-pin",
    componet: <Check component={MSDK} />,
    layout: "/ee-2-jefe-municipal",
  },


]; 
export default routes;
